import { Controller } from "@hotwired/stimulus";

const CLOSED = false;
const OPEN = true;

export default class extends Controller {
  static classes = [
    "openBackdrop",
    "openMenu",
    "openCloseButton",
    "closedBackdrop",
    "closedMenu",
    "closedCloseButton",
    "closedContainer",
  ];

  static targets = ["menu", "menuContainer", "backdrop", "closeButton"];

  open() {
    this.menuContainerTarget.classList.remove(this.closedContainerClass);

    requestAnimationFrame(() => {
      this.toggleClasses(OPEN);
    });
  }

  close() {
    this.toggleClasses(CLOSED);

    setTimeout(() => {
      this.menuContainerTarget.classList.add(this.closedContainerClass);
    }, 300);
  }

  toggleClasses(state) {
    this.backdropTarget.classList.toggle(this.openBackdropClass, state === OPEN);
    this.backdropTarget.classList.toggle(this.closedBackdropClass, state === CLOSED);
    this.menuTarget.classList.toggle(this.openMenuClass, state === OPEN);
    this.menuTarget.classList.toggle(this.closedMenuClass, state === CLOSED);
    this.closeButtonTarget.classList.toggle(this.openCloseButtonClass, state === OPEN);
    this.closeButtonTarget.classList.toggle(this.closedCloseButtonClass, state === CLOSED);
  }
}
